<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pkppqj/tc-custom/9781625673886.jpg?1726444326051" alt="This image is the cover for the book Witch, Doppelganger"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Witch, Doppelganger
      </h1>
      <p class="bookDescription body article font2">
        <b>Revolution has come to Starfall.</b><br/><br/>To some, Mirei is a savior. Born from the union of opposing forces, her existence offers a way to heal the division between warrior and witch, and brings powerful new magic into the world.<br/><br/>To others, Mirei is an abomination. She overturns the ancient traditions of the witches, threatening their stability and corrupting their magic with an influence that should be destroyed.<br/><br/>But even Mirei's power is not enough to prevent a civil war. And while she struggles to reconcile Starfall's opposing factions, a more insidious threat is building within her -- because her newfound magic does not come without a price.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marie Brennan
      </h2>
      
      <p class="authorDescription body article">Marie Brennan is a former anthropologist and folklorist who shamelessly pillages her academic fields for material. She most recently misapplied her professors’ hard work to the Hugo Award-nominated Victorian adventure series The Memoirs of Lady Trent; the first book of that series, <i>A Natural History of Dragons</i>, was a finalist for the World Fantasy Award and won the Prix Imaginales for Best Translated Novel. She is also the author of the Doppelganger duology of <i>Warrior</i> and <i>Witch</i>, the urban fantasies <i>Lies and Prophecy</i> and <i>Chains and Memory</i>, the Onyx Court historical fantasy series, the Varekai novellas, the collaborative novel <i>Born to the Blade</i>, and more than fifty short stories. For more information, visit <a href="http://www.swantower.com">www.swantower.com.</a></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JABberwocky Literary Agency, Inc
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?676294d8